import React from "react";
import { Award, Users, Target, Shield } from "lucide-react";

const AboutUs = () => {
  return (
    <section id="about-us" className="py-12 md:py-20 bg-white min-h-screen">
      <div className="container mx-auto px-6">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6">
            About Us
          </h2>
          <div className="w-24 h-1 bg-secondary mx-auto mb-8"></div>
        </div>

        {/* Main Content */}
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none mb- text-justify">
            <p className="text-slate-700 leading-relaxed text-lg mb-6 text-justify">
              Our firm was founded by <strong>Mohammad Hussein Merhi</strong>, a
              licensed auditor and member of the{" "}
              <strong>
                Lebanese Association of Certified Public Accountants (LACPA)
              </strong>{" "}
              . Established with a clear vision, the firm combines strong
              technical foundations with a modern, forward-looking approach to
              professional services.
            </p>

            <p className="text-slate-700 leading-relaxed text-lg mb-6">
              Mr. Merhi brings a new generation mindset to the audit and
              advisory profession. Young, dynamic, and detail-oriented, he has
              built his career on continuous learning, adaptability, and a deep
              understanding of today's evolving business environment. Since the
              beginning of his professional journey, he has demonstrated
              consistent growth, earning the trust of clients through
              commitment, precision, and practical solutions.
            </p>

            <p className="text-slate-700 leading-relaxed text-lg mb-6">
              Under his leadership, the firm is dedicated to delivering
              high-quality audit, accounting, tax, and advisory services in full
              compliance with Lebanese regulations and international standards.
              We believe in building long-term relationships, offering
              personalized attention, and supporting our clients with clear,
              reliable, and value-driven financial insights.
            </p>

            <p className="text-slate-700 leading-relaxed text-lg">
              Our approach blends professionalism, integrity, and modern
              thinking—helping businesses navigate complexity with confidence
              and clarity.
            </p>
          </div>

          {/* Values Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
            <div className="bg-slate-50 p-6 rounded-xl text-center">
              <div className="bg-primary p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <Award className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-2">
                Licensed & Certified
              </h3>
              <p className="text-slate-600 text-sm">LACPA registered member</p>
            </div>

            <div className="bg-slate-50 p-6 rounded-xl text-center">
              <div className="bg-primary p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <Users className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-2">
                Client-Focused
              </h3>
              <p className="text-slate-600 text-sm">
                Building long-term relationships
              </p>
            </div>

            <div className="bg-slate-50 p-6 rounded-xl text-center">
              <div className="bg-primary p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <Target className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-2">
                Modern Approach
              </h3>
              <p className="text-slate-600 text-sm">
                Forward-looking solutions
              </p>
            </div>

            <div className="bg-slate-50 p-6 rounded-xl text-center">
              <div className="bg-primary p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-2">Compliant</h3>
              <p className="text-slate-600 text-sm">
                Lebanese & international standards
              </p>
            </div>
          </div>

          {/* CTA Section */}
          <div className="mt-16 text-center">
            <div className="bg-primary rounded-2xl p-8 md:p-12 text-white">
              <h3 className="text-2xl md:text-3xl font-bold mb-4">
                Focus on growing your business.
              </h3>
              <p className="text-slate-200  text-xl mb-6 max-w-2xl mx-auto">
                Trust the numbers to us!
              </p>
              <a
                href="#contact"
                className="inline-block bg-secondary hover:bg-white hover:text-primary text-white px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105"
              >
                Get in Touch
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
